import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PaginationProps } from '@/types/paginate';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className = '',
}: PaginationProps) => {
  const renderPaginationItems = (): React.ReactElement[] => {
    const items: React.ReactElement[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`w-8 h-8 flex items-center justify-center rounded-md ${
              currentPage === i
                ? 'bg-primary text-white'
                : 'text-gray-700 hover:bg-primary-50'
            }`}
            aria-label={`${i} хуудас`}
            aria-current={currentPage === i ? 'page' : undefined}
          >
            {i}
          </button>
        );
      }
      return items;
    }

    let startPage, endPage;

    if (currentPage <= 2) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage >= totalPages - 1) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }

    if (startPage > 1) {
      items.push(
        <span
          key="start-dots"
          className="w-8 h-8 flex items-center justify-center text-gray-500"
        >
          ...
        </span>
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`w-8 h-8 flex items-center justify-center rounded-md ${
            currentPage === i
              ? 'bg-primary text-white'
              : 'text-gray-700 hover:bg-primary-50'
          }`}
          aria-label={`${i} хуудас`}
          aria-current={currentPage === i ? 'page' : undefined}
        >
          {i}
        </button>
      );
    }

    if (endPage < totalPages) {
      items.push(
        <span
          key="end-dots"
          className="w-8 h-8 flex items-center justify-center text-gray-500"
        >
          ...
        </span>
      );
    }

    return items;
  };

  return (
    <div
      className={`flex justify-center items-center space-x-2 py-4 ${className}`}
    >
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`p-2 rounded-md ${
          currentPage === 1
            ? 'text-gray-400 cursor-not-allowed'
            : 'text-primary hover:bg-primary-50'
        }`}
        aria-label="Өмнөх хуудас"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      <div className="flex space-x-1">{renderPaginationItems()}</div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`p-2 rounded-md ${
          currentPage === totalPages
            ? 'text-gray-400 cursor-not-allowed'
            : 'text-primary hover:bg-primary-50'
        }`}
        aria-label="Дараагийн хуудас"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
};

export default Pagination;
